import { registerPlugin } from '@capacitor/core';

export interface ExternalBrowserPlugin {
    open(options: { link: string }): Promise<void>;
}

const ExternalBrowserPlugin = registerPlugin<ExternalBrowserPlugin>("ExternalBrowserPlugin");

export default ExternalBrowserPlugin;